export default "__VITE_ASSET__04XjSYb7__"